<template>
  <div>
    <main-navbar type="9"></main-navbar>
    <div class="container">
      <div>
        <main-menu type="0"></main-menu>
      </div>
      <div class="row">
        <!--        <div class="col-sm-3 d-none d-sm-block menu-group">-->
        <left-bar></left-bar>
        <!--        </div>-->

        <div class="col-sm-9 col-12 bg-opacity-10 border-none pt-0 bglight mt-2">
          <main-category-bar
              v-bind:activeId="currentTagId"
              v-on:get-tagid="gotTagId"
              v-bind:data="maincategory">
          </main-category-bar>
          <div
              v-infinite-scroll="loadArticle"
              infinite-scroll-disabled="disabled"
              infinite-scroll-distance="50">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 bg-none">
              <group-card-item
                  v-for="item in articlelists"
                  v-bind:key="item.articleID"
                  v-bind:data="item"
                  type="0">
              </group-card-item>
            </div>
          </div>
          <div class="text-center py-5" v-if="loading.article"><!-- loader -->
            <i class="now-ui-icons loader_refresh spin"></i>
          </div>
          <p class="text-center py-4 nomore" v-if="noMore">-- 没有更多内容 --</p>
        </div>
        <div class="col-sm-3 px-0 d-none d-sm-block">
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import MainNavbar from '@/layout/MainNavbar.vue';
import icons from "@/components/Icons/Icons";
import MainMenu from '@/module/group/pages/components/Main/MainMenu';
import MainCategoryBar from '@/module/group/pages/components/Main/MainCategoryBar';
import LeftBar from '@/module/group/user/group/LeftBar.vue';
import group from '@/module/group/group.service';
import GroupCardItem from '@/module/group/pages/components/Main/GroupCardItem';

export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    MainNavbar,
    MainMenu,
    MainCategoryBar,
    LeftBar,
    GroupCardItem
  },
  created () {
    group.group_tag().then(res=>{
      if(res.status){
        this.maincategory=res.data;
      }
    }).catch(err=>{
      console.log(err);
    });
    this.loadArticle()


  },
  methods:{
    gotTagId(id){
      this.currentTagId = id;
      this.LastID = 0;
      this.articlelists = [];
      this.loadArticle();
    },
    loadArticle(){
      this.loading.article=true;
      group.hot_group(this.currentTagId,this.LastID).then(res=>{
        if(res.status){
          let arr = res.data;
          // api 未更新到wwww 时使用 禁止翻页
          // this.noMore = arr.length =24 ;
          // api 更新后
          this.noMore = arr.length < 23? true : false;
          this.LastID=arr[arr.length-1]['count_article_month']
          this.articlelists = this.articlelists.concat(arr);
          this.loading.article=false;
        }
      })
    },
    // loadArticle(){
    //   this.loading.article=true;
    //   group.hot_group(this.currentTagId,this.LastID).then(res=>{
    //     if (res.status) {
    //      let arr = res.data;
    //       this.loadmore(arr,'count_article_month')
    //       this.articlelists = this.articlelists.concat(arr);
    //       this.loading.article=false;
    //     }
    //   })
    // },

  },
  data() {
    return {
      // lastID:0,
      currentTagId:0,
      noMore:false,
      LastID:0,
      loading:{article:true,TagId:true},
      // loading:{article:true,TagId:true},
      maincategory:[
        // {id:'0',name:'影视',visible:1},
      ],
      articlelists: [],
      icons:icons,
    };
  },
  computed:{
    disabled () {
      return this.loading.article || this.noMore
    }
  }
};
</script>
<style>

.bglight{
  background: #f6f6f6!important
}
.nomore {
  text-align: center;
  margin: 20px 0;
  font-size: 16px;
  color: #838383;
}
</style>
